import React, { memo } from "react"
import Block from "./Block"
import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles(theme => ({
  bibleText: {
    width: "100%",
    position: "relative",
  },
}))

const BibleText = memo(
  ({
    content,
    verbViewDialog,
    newSourceViewDialog,
    newInterlinearDialog,
    newSphereViewDialog,
    newValuesDialog,
    language,
    version,
    versification,
    showSpheres,
    showValues,
    versificationType,
    availableBooks,
    navigateToRef,
    translate,
    displayRef,
    showQA,
    showGAP,
  }) => {
    const classes = useStyles()
    return (
      <div className={classes.bibleText}>
        {content.map((block, bIndex) => (
          <Block
            key={bIndex + "-block"}
            bIndex={bIndex}
            content={block}
            verbViewDialog={verbViewDialog}
            newSourceViewDialog={newSourceViewDialog}
            newInterlinearDialog={newInterlinearDialog}
            newSphereViewDialog={newSphereViewDialog}
            newValuesDialog={newValuesDialog}
            language={language}
            version={version}
            versification={versification}
            showSpheres={showSpheres}
            showValues={showValues}
            versificationType={versificationType}
            availableBooks={availableBooks}
            navigateToRef={navigateToRef}
            translate={translate}
            displayRef={displayRef}
            showQA={showQA}
            showGAP={showGAP}
          />
        ))}
      </div>
    )
  }
)

export default BibleText
